import '@ionic/core';
import { Component, Prop, h} from '@stencil/core';

import '../selector-opportunity-type/selector-opportunity-type';
import '../selector-area-type/selector-area-type';
import '../selector-partner-type/selector-partner-type';
import '../selector-region-type/selector-region-type';

@Component({
  tag: 'filter-palette',
  styleUrl: 'filter-palette.css',
  shadow: true
})
export class FilterPalette {
    @Prop() cohortId: number = 0;
    @Prop() typeSelections: Array<string>;
    @Prop() areaSelections: Array<string>;
    @Prop() partnerSelections: Array<string>;
    @Prop() regionSelections: Array<string>;

    render() {
        return (
            <div id="SSPBCatalogFilterPalette">
                <selector-opportunity-type class="SSPBFilterSelector" cohort-id={this.cohortId} typeSelections={this.typeSelections} />
                <selector-area-type class="SSPBFilterSelector" cohort-id={this.cohortId} areaSelections={this.areaSelections} />
                <selector-partner-type class="SSPBFilterSelector" cohort-id={this.cohortId} partnerSelections={this.partnerSelections} />
                <selector-region-type class="SSPBFilterSelector" cohort-id={this.cohortId} regionSelections={this.regionSelections} />
                <div class="ClearBoth">&nbsp;</div>
            </div>
        );
    }
}
